var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _g2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetstartedDiscovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 77,
    viewBox: "0 0 99 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20508,
    y: 9.83789,
    width: 54.4496,
    height: 65.7395,
    rx: 3,
    fill: "#F6FAF9",
    stroke: "#82A4A6",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9302,
    y: 17.2979,
    width: 34.5,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.43018,
    y: 25.0342,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.43018,
    y: 32.7705,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.43018,
    y: 40.5068,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.43018,
    y: 55.9795,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.43018,
    y: 48.2432,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.43018,
    y: 63.7158,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_212_86)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5874,
    y: 2.43408,
    width: 54.4496,
    height: 65.7395,
    rx: 3,
    fill: "#FEFEFE",
    stroke: "#48A392",
    strokeWidth: 2
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 54.8579,
    y: 9.89404,
    width: 34.5,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3579,
    y: 17.6304,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3579,
    y: 25.3667,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3579,
    y: 33.103,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3579,
    y: 48.5757,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3579,
    y: 40.8394,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3579,
    y: 56.312,
    width: 44,
    height: 4.40169,
    fill: "#D9D9D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_212_86)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.9397,
    cy: 37.5357,
    r: 14.3296,
    fill: "#71CC8B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.969 37.3623H48.6759",
    stroke: "#044154",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2029 32.5581L48.676 37.3623",
    stroke: "#044154",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.676 37.3623L44.2029 42.1665",
    stroke: "#044154",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_212_86",
    x: 35.5874,
    y: 0.434082,
    width: 62.4497,
    height: 73.7397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_86"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_86",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_212_86",
    x: 24.6101,
    y: 23.2061,
    width: 32.6592,
    height: 32.6592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_86"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_86",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetstartedDiscovery);
export default __webpack_public_path__ + "static/media/getstarted-discovery.e41d5304a6b3840f6218768423bf363f.svg";
export { ForwardRef as ReactComponent };